import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { Breadcrumb, Dropdown } from 'react-bootstrap';
import { getPathCrumbs } from './BreadcrumbsData';


//var compFullWidth = 0;
function Breadcrumbs ({ path }) {

    const [crumbs, setCrumbs] = useState(getPathCrumbs(path));
    const breadRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    /**TODO: Comment below to reflect the design update: no wrap, no ellipsis */

    useEffect(() => {
        //setIsOverflow(false);
        setCrumbs(getPathCrumbs(path));
        // if (document.readyState === 'complete' || document.readyState === 'interactive') {
        //     const w = breadRef.current.scrollWidth;
        //     //console.log("useEffect BreadCrumb", w);
        //     compFullWidth = (w);
        //     //console.log("useEffect BreadCrumb", window.innerWidth, window.innerWidth < w);
        //     setIsOverflow(window.innerWidth < w ? true : false);
        // }
    }, [path])

    // function handleResize (ev) {

    //     //console.log(ev);
    //     //console.log('resize');
    //     //console.log(breadRef);

    //     //console.log("Window: " + window.innerWidth);
    //     //console.log("Breads: " + breadRef.current.scrollWidth);
    //     //console.log("CompFull: " + compFullWidth);
    //     var inner = ev.target.innerWidth;

    //     //console.log("inner", ev.target.innerWidth);
    //     if (inner < compFullWidth) {
    //         //console.log("Overflow true");
    //         //if(isOverflow!=true){

    //         setIsOverflow(true);
    //         //}
    //     }
    //     else {
    //         if (breadRef.current.scrollWidth != compFullWidth) {
    //             compFullWidth = breadRef.current.scrollWidth;
    //         }
    //         //if(isOverflow!=false){
    //         //console.log("no overflow");
    //         setIsOverflow(false);
    //         //}
    //     }
    // }

    // useEffect(() => {
    //     if (document.readyState === 'complete' || document.readyState === 'interactive') {
    //         const w = breadRef.current.scrollWidth;
    //         //console.log("breadCrumb handleResize compFullWidth", w);
    //         compFullWidth = (w);
    //         //console.log("breadCrumb handleResize innder width", window.innerWidth, window.innerWidth < w);
    //         setIsOverflow(window.innerWidth <= w ? true : false);
    //     }

    //     window.addEventListener('resize', handleResize);

    // }, []);

    return (
        crumbs != null
            ?
            <div className="breadcrumb-container" >
                <Breadcrumb ref={breadRef} className="w-xs-fit-content flex-nowrap p-0">
                    {
                        crumbs.length >= 3
                            ?
                            <>
                                <Breadcrumb.Item
                                    linkAs={Link}
                                    linkProps={{ to: crumbs[0].path }}

                                >
                                    {crumbs[0].name}
                                </Breadcrumb.Item>
                                <>
                                    {   /**TODO: Comment below to reflect the design update: no wrap, no ellipsis */
                                        // isOverflow == false
                                        //     ?
                                        crumbs.map((crumb, index) => {
                                            if (index == 0 || index == (crumbs.length - 1)) {
                                                return (
                                                    null
                                                );
                                            }
                                            else {
                                                return (
                                                    <Breadcrumb.Item
                                                        linkAs={Link}
                                                        linkProps={{ to: crumb.path }}

                                                    >
                                                        {crumb.name}
                                                    </Breadcrumb.Item>
                                                );
                                            }

                                        })
                                        /**TODO: Comment below to reflect the design update: no wrap, no ellipsis */
                                        // :

                                        // <Breadcrumb.Item
                                        //     linkAs={Dropdown}
                                        //     linkProps={{
                                        //         variant: 'clear',
                                        //         className: "p-0"
                                        //     }}
                                        //     className="breadcrumb-dropdown-item"
                                        // >
                                        //     <Dropdown>
                                        //         <Dropdown.Toggle variant="" id="dropdown-basic" className="p-1">
                                        //             ...
                                        //         </Dropdown.Toggle>

                                        //         <Dropdown.Menu className=" w-sm-fit-content">
                                        //             <div className="dropdown-breadcrumbs">
                                        //                 {
                                        //                     crumbs.map((crumb, index) => {
                                        //                         if (index == 0 || index == (crumbs.length - 1)) {
                                        //                             return (
                                        //                                 null
                                        //                             );
                                        //                         }
                                        //                         else {
                                        //                             return (
                                        //                                 <Dropdown.Item href={crumb.path}>{crumb.name}</Dropdown.Item>
                                        //                             );
                                        //                         }

                                        //                     })
                                        //                 }
                                        //             </div>
                                        //         </Dropdown.Menu>
                                        //     </Dropdown>

                                        // </Breadcrumb.Item>
                                    }
                                </>

                                <Breadcrumb.Item active className={isOverflow == true ? "overflow-active" : ""}>
                                    <span>{crumbs[crumbs.length - 1].name}</span>
                                </Breadcrumb.Item>

                            </>
                            :
                            crumbs.map((crumb, index) => {
                                //console.log(crumb);

                                if (index == crumbs.length - 1) {
                                    return (
                                        <Breadcrumb.Item active >
                                            {crumb.name}
                                        </Breadcrumb.Item>
                                    );
                                }
                                else {
                                    if (index == 0) {
                                        return (
                                            <Breadcrumb.Item
                                                linkAs={Link}
                                                linkProps={{ to: crumb.path }}
                                                className=""
                                            >
                                                {crumb.name}
                                            </Breadcrumb.Item>
                                        );
                                    }
                                    else {
                                        return (
                                            <Breadcrumb.Item
                                                linkAs={Link}
                                                linkProps={{ to: crumb.path }}
                                                className=""
                                            >
                                                {crumb.name}
                                            </Breadcrumb.Item>
                                        );
                                    }

                                }
                            })
                    }
                </Breadcrumb>
            </div>
            : null
        /**TODO: Comment below to reflect the design update: no wrap, no ellipsis*/
        // crumbs != null
        //     ?
        //     <div className="breadcrumb-container" >
        //         <Breadcrumb ref={breadRef} className="w-xs-fit-content flex-nowrap p-0">
        //             {
        //                 crumbs.length >= 3
        //                     ?
        //                     <>
        //                         <Breadcrumb.Item
        //                             linkAs={Link}
        //                             linkProps={{ to: crumbs[0].path }}

        //                         >
        //                             {crumbs[0].name}
        //                         </Breadcrumb.Item>
        //                         <>
        //                             {
        //                                 isOverflow == false
        //                                     ?
        //                                     crumbs.map((crumb, index) => {
        //                                         if (index == 0 || index == (crumbs.length - 1)) {
        //                                             return (
        //                                                 null
        //                                             );
        //                                         }
        //                                         else {
        //                                             return (
        //                                                 <Breadcrumb.Item
        //                                                     linkAs={Link}
        //                                                     linkProps={{ to: crumb.path }}

        //                                                 >
        //                                                     {crumb.name}
        //                                                 </Breadcrumb.Item>
        //                                             );
        //                                         }

        //                                     })
        //                                     :

        //                                     <Breadcrumb.Item
        //                                         linkAs={Dropdown}
        //                                         linkProps={{
        //                                             variant: 'clear',
        //                                             className: "p-0"
        //                                         }}
        //                                         className="breadcrumb-dropdown-item"
        //                                     >
        //                                         <Dropdown>
        //                                             <Dropdown.Toggle variant="" id="dropdown-basic" className="p-1">
        //                                                 ...
        //                                             </Dropdown.Toggle>

        //                                             <Dropdown.Menu className=" w-sm-fit-content">
        //                                                 <div className="dropdown-breadcrumbs">
        //                                                     {
        //                                                         crumbs.map((crumb, index) => {
        //                                                             if (index == 0 || index == (crumbs.length - 1)) {
        //                                                                 return (
        //                                                                     null
        //                                                                 );
        //                                                             }
        //                                                             else {
        //                                                                 return (
        //                                                                     <Dropdown.Item href={crumb.path}>{crumb.name}</Dropdown.Item>
        //                                                                 );
        //                                                             }

        //                                                         })
        //                                                     }
        //                                                 </div>
        //                                             </Dropdown.Menu>
        //                                         </Dropdown>

        //                                     </Breadcrumb.Item>
        //                             }
        //                         </>

        //                         <Breadcrumb.Item active className={isOverflow == true ? "overflow-active" : ""}>
        //                             <span>{crumbs[crumbs.length - 1].name}</span>
        //                         </Breadcrumb.Item>

        //                     </>
        //                     :
        //                     crumbs.map((crumb, index) => {
        //                         //console.log(crumb);

        //                         if (index == crumbs.length - 1) {
        //                             return (
        //                                 <Breadcrumb.Item active >
        //                                     {crumb.name}
        //                                 </Breadcrumb.Item>
        //                             );
        //                         }
        //                         else {
        //                             if (index == 0) {
        //                                 return (
        //                                     <Breadcrumb.Item
        //                                         linkAs={Link}
        //                                         linkProps={{ to: crumb.path }}
        //                                         className=""
        //                                     >
        //                                         {crumb.name}
        //                                     </Breadcrumb.Item>
        //                                 );
        //                             }
        //                             else {
        //                                 return (
        //                                     <Breadcrumb.Item
        //                                         linkAs={Link}
        //                                         linkProps={{ to: crumb.path }}
        //                                         className=""
        //                                     >
        //                                         {crumb.name}
        //                                     </Breadcrumb.Item>
        //                                 );
        //                             }

        //                         }
        //                     })
        //             }
        //         </Breadcrumb>
        //     </div>
        //     : null
    );
}

export default Breadcrumbs;